"use strict";
// Copyright © Veeam Software Group GmbH.
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarGroup = void 0;
const types_1 = require("../../Toolbar/types");
function toolbarGroup(config) {
    var _a;
    const result = (model) => {
        var _a, _b;
        const items = (_a = config === null || config === void 0 ? void 0 : config.items) === null || _a === void 0 ? void 0 : _a.map((item) => item(model));
        return {
            type: types_1.TOOLBAR_ITEM_TYPE.group,
            isAction: (_b = config === null || config === void 0 ? void 0 : config.isAction) !== null && _b !== void 0 ? _b : true,
            text: config === null || config === void 0 ? void 0 : config.title,
            iconSrc: config === null || config === void 0 ? void 0 : config.icon,
            disabled: config === null || config === void 0 ? void 0 : config.disabled,
            hidden: config === null || config === void 0 ? void 0 : config.hidden,
            items,
            tooltip: config === null || config === void 0 ? void 0 : config.tooltip
        };
    };
    const formatToContextMenu = (item, itemConfig) => {
        var _a;
        return Object.assign(Object.assign({}, item), { items: (_a = itemConfig === null || itemConfig === void 0 ? void 0 : itemConfig.contextMenu) === null || _a === void 0 ? void 0 : _a.items, separator: item.type === types_1.TOOLBAR_ITEM_TYPE.separator, icon: item === null || item === void 0 ? void 0 : item.iconSrc, title: (item === null || item === void 0 ? void 0 : item.text) || '', handler: item === null || item === void 0 ? void 0 : item.onClick });
    };
    const isItemSuitableForContextMenu = (item, itemConfig) => {
        if (item.type === types_1.TOOLBAR_ITEM_TYPE.button && !itemConfig.contextMenu) {
            return false;
        }
        return [
            types_1.TOOLBAR_ITEM_TYPE.button,
            types_1.TOOLBAR_ITEM_TYPE.group,
            types_1.TOOLBAR_ITEM_TYPE.separator
        ].includes(item.type);
    };
    const items = (_a = config === null || config === void 0 ? void 0 : config.items) === null || _a === void 0 ? void 0 : _a.reduce((items, item) => {
        const builtItem = item();
        if (isItemSuitableForContextMenu(builtItem, item)) {
            return [...items, formatToContextMenu(builtItem, item)];
        }
        return items;
    }, []);
    result.contextMenu = {
        icon: config === null || config === void 0 ? void 0 : config.icon,
        title: (config === null || config === void 0 ? void 0 : config.title) || '',
        items
    };
    return result;
}
exports.toolbarGroup = toolbarGroup;
//# sourceMappingURL=toolbarGroup.js.map